export const standardAppendixRulePathName = 'standard-appendix-rule'; // Skabeloner og Bilag: Regler for standard bilag
export const standardAppendixPathName = 'standard-appendix'; // Skabeloner og Bilag: Standardbilag
